'use strict'

const React = require('react')
const ReactDOM = require('react-dom')
const ReactDOMServer = require('react-dom/server')
const Helpers = require('../../../../_plugins/lib/helpers')
const getAirportInfo = require('./getAirportInfo')
const propTypes = require('prop-types');
const tracker = require('../../../../_plugins/lib/tracker.js')
const { array, string, object } = propTypes
const createReactClass = require('create-react-class');

const SmartyContent = createReactClass({
  mixins: [Helpers],

  propTypes: {
    theContent: array.isRequired,
    productData: object,
    location: string,
    pageData: object,
    phoneNumber: string
  },

  getDefaultProps () {
    return {
      theContent: [ ]
    }
  },

  shouldComponentUpdate () {
    return false
  },

  changeTab (e) {
    let anchor = e.target
    let hash = anchor.getAttribute('href')
    // Sometimes there are icons inside the anchor that get targetted on click, so when this happens we target the parent
    if (hash === null) anchor = anchor.parentNode
    hash = anchor.getAttribute('href')
    const map = anchor.getAttribute('data-load-map')
    const initMap = anchor.getAttribute('onclick')
    let parentElement = anchor.parentNode
    // Solves safari issue with persisted tab when it doesnt have any content (its a link)
    if (hash === '') return true
    tracker.track('TabChange', hash.replace('#', ''))
    // Necessary loop to make sure that we are selecting the correct tabs, sometimes we have tabs in tabs and they can get confused.
    const parentContainer = this.getParentNode(anchor, 3)
    for (let child = 0; child < parentContainer.children.length; child++) {
      for (let node = 0; node < parentContainer.children[child].children.length; node++) {
        parentContainer.children[child].children[node].classList.remove('active')
      }
    }
    this.$(hash, document).classList.add('active')
    parentElement.classList.add('active')
    if (map && google) google.maps.event.trigger(this.$(map, document), 'resize') // eslint-disable-line no-undef
    if (initMap === 'initGoogleMap()' && google) google.maps.event.trigger(this.$('#theMap', document), 'resize') // eslint-disable-line no-undef
    e.preventDefault()
    return false
  },

  openInNewWindow (e) {
    if (typeof window === 'undefined') return false
    window.open(e.target.getAttribute('data-newwindow'), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600')
    return false
  },

  replaceComponents () {
    const { theContent } = this.props
    const props = this.props
    const container = this.$('#ContentArea', document)
    theContent.filter(item => {
      return item.isCode
    }).map((item, index) => {
      const parent = this.$('#' + item.id, container)
      if (!parent) return
      const children = parent.parentNode.childNodes
      let childNodes = []
      let checked = false
      for (let i = 0; i < children.length; i++) {
        const node = children[i]
        if (node.id === item.id) {
          checked = !checked
          continue
        }
        if (checked) childNodes.push({ node, checked })
        else childNodes.unshift({ node, checked })
      }
      ReactDOM.render(<item.contents {...props} functionParams={item.props} id={item.id + '-new'} key={index} />, parent)
      childNodes.map(child => {
        if (child.checked) parent.parentNode.appendChild(child.node)
        else parent.parentNode.insertBefore(child.node, parent.parentNode.firstChild)
      })
    })
  },

  getOutputHtml () {
    const { theContent } = this.props
    const location = getAirportInfo(this.props.pageData.pageName)
    const output = theContent.map((item, index) => {
      if (!item.isCode) return item.contents
      if (typeof document === 'undefined' || !item.renderAtBuildTimeOnly) return (ReactDOMServer.renderToStaticMarkup(<item.contents id={item.id} functionParams={item.props} {...this.props} location={location} key={index} />))
      if (!this.$('#' + item.id, document)) return
      item.contents = this.$('#' + item.id, document).outerHTML
      item.isCode = false
      return item.contents
    }).join('')
    return output
  },

  hashScroll (item) {
    window.scrollTo(0, item.offsetTop)
  },

  componentDidMount () {
    const hashLinks = this.$$('#ContentArea a[href^="#"]', document)
    for (let i = 0; i < hashLinks.length; i++) {
      hashLinks[i].onclick = this.hashScroll
    }
    const navTabs = this.$$('#ContentArea .nav-tabs a', document)
    for (let i = 0; i < navTabs.length; i++) {
      navTabs[i].onclick = this.changeTab
    }
    const newWindowLinks = this.$$('#ContentArea a[data-newwindow]', document)
    for (let i = 0; i < newWindowLinks.length; i++) {
      newWindowLinks[i].onclick = this.openInNewWindow
    }
    this.replaceComponents()
  },

  render () {
    return (
      <div id='ContentArea' dangerouslySetInnerHTML={{ __html: this.getOutputHtml() }} />
    )
  }
})

module.exports = SmartyContent





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/smartyContent.jsx